<template>
  <div id="cashierGoodsDetails" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <div class="rc-title flex-between">
      <div>会员</div>
      <div class="back" @click="back">X</div>
    </div>
    <div class="content-wrap">
      <div>
        <div style="margin-top:20px">会员手机号</div>
        <div class="buy">
          <input class="buyInput" placeholder="请输入完整会员手机号查询" v-model="phoneNum" @keyup.enter="searchVip" />
        </div>
      </div>

      <div class="confirm">
        <el-button type="primary" @click="searchVip">确定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import { shopMemberList } from "../api";
export default {
  data() {
    return {
      phoneNum: "",
      userList: "",
      shopInformation: "",
      loading: false
    };
  },
  created() {
    let userList = JSON.parse(this.getCookie("userList"));
    let shopInformation = JSON.parse(this.getCookie("shopInformation"));
    this.userList = userList;
    this.shopInformation = shopInformation;
  },
  methods: {
    searchVip() {
      this.$store.state.status = 2
      this.loading = true
      if ((/^1(3|4|5|6|7|8|9)\d{9}$/.test(this.phoneNum))) {
        this.shopMemberList(this.phoneNum);
      }else{
        this.$message.error('请输入正确手机号');
        this.loading = false
      }
    },
    shopMemberList(phone11Num) {
      shopMemberList({
        sessionId: this.userList.sessionId,
        userId: this.userList.id,
        phone11Num: phone11Num
      })
        .then(res => {
          this.loading = false
          // console.log(res.data, "获取商品列表");
          if (res.code == 1) {
            //  this.$store.state.offers.type = 0;
            this.$router.push({path:'cashierOrderVip/vipInformation',query:{phoneNum:this.phoneNum}})
            this.$store.state.offers.vipIfm =res.data[0];
            console.log(res.data[0], 'res.data[0]')
          } else if (res.code == 2) {
            this.$message.error(res.msg);
            this.$router.push("/");
          } else if(res.code == -1){
            this.$message.error(this.phoneNum+'还不是会员');
            this.$router.push({path:'cashierOrderVip/addVip',query:{phoneNum:this.phoneNum}})
          }
        })
        .catch(function(error) {
          //   alert("商品接口网络错误，不能访问");
          //   console.log(error);
        });
    },
    back() {
      this.$router.push('/cashierOrder/cashierOrderHome');
    },
    add() {
      this.$store.state.cartList.push({});
    }
  }
};
</script>

<style scoped>
.buy {
  position: relative;
}
.unit {
  position: absolute;
  top: 20px;
  left: 110px;
  color: #999999;
}
.confirm {
  position: absolute;
  right: 20px;
  bottom: 20px;
}
#cashierGoodsDetails {
  height: 100%;
  width: 100%;
}
.buyInput {
  width: 200px;
  padding: 12px 41px;
  margin-top: 10px;
}
.product2 {
  padding: 12px 41px;
  /* background: rgba(30, 148, 234, 1); */
  border: 1px solid rgba(30, 148, 234, 1);
  border-radius: 2px;
  color: rgba(30, 148, 234, 1);
  display: inline-block;
  margin-top: 10px;
  font-size: 14px;
}
.product {
  padding: 12px 41px;
  background: rgba(30, 148, 234, 1);
  border: 1px solid rgba(16, 142, 233, 1);
  border-radius: 2px;
  color: #fff;
  display: inline-block;
  margin-top: 10px;
  font-size: 14px;
}
.borderBottom {
  padding-bottom: 10px;
  border-bottom: 1px solid #eeeeee;
  margin-bottom: 10px;
}
.goodsSprice {
  color: #f92323;
}
.goodsName {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.goodsText {
  margin-left: 15px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}
.goodsImg img {
  height: 100px;
  width: 100px;
}
.content-wrap {
  padding: 23px 26px;
  font-size: 14px;
}
.back {
  color: gray;
  font-size: 20px;
  cursor: pointer;
}
.rc-title {
  /* background: #eeeeee; */
   border-bottom: 1px solid #eee;
  box-sizing: border-box;
  padding: 18px;
  height: 60px;
  font-size: 16px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/cashierOrderVip.vue